import React, { useEffect, useMemo, useState } from 'react';
import { Dropdown, Table, Tooltip } from 'antd';
import { number_format } from '@utils/widget';
import './headcountSalesTable.scss';
import CountryFilter from '@modules/analysis/detail/headcountSalesByCountry/HeadcountSalesTable/CountryFilter';
import D_Number from '@utils/number';
// import { TreeMapType } from '@modules/analysis/detail/headcountSalesByCountry';

const filterIcon = (active) => (
  <span
    className={`appkiticon icon-filter-outline ${active ? 'active' : ''}`}
  />
);

const tooltipCellRender = (text) =>
  text ? <Tooltip title={text}>{text}</Tooltip> : '-';

function HeadcountSalesTable({
  dataSource = [],
  selectedCountry = [],
  headcountVisible,
  updateSelectedCountry,
  allCountries,
  type,
  focusedCountry,
  topAddon = null,
}) {
  const [filterVisible, setFilterVisible] = useState(false);
  const columns = useMemo(
    () => [
      {
        // title: 'Country',
        title: (
          <div>
            Country
            <Dropdown
              trigger={['click']}
              placement="bottomCenter"
              visible={filterVisible}
              onVisibleChange={setFilterVisible}
              overlay={
                <CountryFilter
                  allCountries={allCountries}
                  selectedKeys={selectedCountry}
                  visible={filterVisible}
                  onSelectedKeyChange={(keys) => {
                    updateSelectedCountry(keys);
                    setFilterVisible(false);
                  }}
                  onCancel={() => setFilterVisible(false)}
                />
              }
            >
              <span className="appkiticon icon-filter-outline filter-icon" />
            </Dropdown>
          </div>
        ),
        dataIndex: 'country',
        key: 'country',
        className: 'headcount-sales-country-cell',
        ellipsis: true,
        align: 'left',
        render(_, record) {
          return tooltipCellRender(record?.country || record?.companyName);
        },
        filterIcon,
        filteredValue: selectedCountry,
        filtered: false,
        // filterDropdown: (
        //   <CountryFilter
        //     allCountries={allCountries}
        //     selectedKeys={selectedCountry}
        //     onSelectedKeyChange={updateSelectedCountry}
        //   />
        // ),
        onFilter: (value, record) => selectedCountry.includes(record?.country),
      },
      headcountVisible
        ? {
            title: 'Employees',
            dataIndex: 'headcount',
            key: 'headcount',
            className: 'headcount-sales-table-cell',
            ellipsis: true,
            align: 'right',
            sorter: (a, b) => a.headcount - b.headcount,
            render: (headcount) => {
              const formattedNumber = D_Number.addSeparator(headcount);
              return formattedNumber ? (
                <Tooltip title={formattedNumber}>
                  <span>{formattedNumber}</span>
                </Tooltip>
              ) : (
                '-'
              );
            },
          }
        : {
            title: 'Sales ($ ‘000S)',
            dataIndex: 'sales',
            key: 'sales',
            className: 'headcount-sales-table-cell',
            ellipsis: true,
            align: 'right',
            sorter: (a, b) => a.sales - b.sales,
            render: (text) => {
              const newText = text && number_format(text / 1000, 0);
              return text ? (
                <Tooltip title={text}>
                  <span>${newText}</span>
                </Tooltip>
              ) : (
                '-'
              );
            },
          },
    ],
    [headcountVisible, filterVisible, allCountries, selectedCountry],
  );

  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [expandAll, setExpandAll] = useState(false);

  const handleCollapseOne = (record) => {
    const key = record?.country || record?.companyName;
    setExpandedRowKeys((state) => state.filter((item, index) => item !== key));
  };
  const handleExpandOne = (record) => {
    setExpandedRowKeys((state) => [
      ...state,
      record?.country || record?.companyName,
    ]);
  };

  const toggleExpandAll = () => {
    if (!expandAll) {
      const allRowKeys = dataSource.map((item, index) => item.country);
      setExpandedRowKeys(allRowKeys);
    } else {
      setExpandedRowKeys([]);
    }
    setExpandAll(!expandAll);
  };

  useEffect(() => {
    setExpandAll(false);
    setExpandedRowKeys([]);
  }, [dataSource, headcountVisible]);

  const childrenColumnName = headcountVisible
    ? 'companyHeadcountList'
    : 'companySalesList';

  // const countriesData = focusedCountry
  //   ? dataSource.filter((e) => e.country === focusedCountry)
  //   : selectedCountry.length
  //   ? dataSource
  //   : [];

  const countriesData = selectedCountry.length ? dataSource : [];

  return (
    <div className="headcount-sales-table">
      {topAddon}
      <div className="expand-btn-wrapper">
        <span onClick={toggleExpandAll}>
          {expandAll ? 'Collapse All' : 'Expand All'}
        </span>
      </div>
      <Table
        columns={columns}
        dataSource={countriesData}
        rowKey={(record) => record?.country || record?.key}
        scroll={{ y: 'calc(100vh - 9.375rem - 9.5rem)' }}
        pagination={false}
        indentSize={12}
        childrenColumnName="companySalesList"
        expandable={{
          expandedRowKeys,
          childrenColumnName,
          expandIcon: ({ expanded, onExpand, record }) => {
            const children = record[childrenColumnName];
            if (children && children.length === 0) {
              return (
                <span className="appkiticon icon-right-chevron-fill a-font-10 arrow-color-disable a-text-grey headcount-sales-table-arrow" />
              );
            }
            if (expanded && children) {
              return (
                <span
                  className="appkiticon icon-down-chevron-fill a-font-10 arrow-color headcount-sales-table-arrow"
                  onClick={(e) => {
                    handleCollapseOne(record);
                  }}
                />
              );
            }
            if (!expanded && children) {
              return (
                <span
                  className="appkiticon icon-right-chevron-fill a-font-10 arrow-color headcount-sales-table-arrow"
                  onClick={(e) => handleExpandOne(record)}
                />
              );
            }
          },
        }}
      />
    </div>
  );
}

export default HeadcountSalesTable;
